import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import {
  frequencyFinancialTransactionsOptions,
  knowledgeFinancialAssetsOptions,
} from '@app/forms/subscription/services/ref';

@Component({
    selector: 'real-estate-markets',
    templateUrl: './real-estate-markets.component.html',
    styleUrls: ['./real-estate-markets.component.scss'],
    standalone: false
})
export class RealEstateMarketsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  knowledgeFinancialAssetsOptions = knowledgeFinancialAssetsOptions;
  frequencyFinancialTransactionsOptions = frequencyFinancialTransactionsOptions;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this, 'accountInformations');
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
